import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/teacherend/login',
    method: 'post',
    data: {
      account:username,
      password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/teacherend/info',
    method: 'get',
    params: { }
  })
}

// export function logout() {
//   return request({
//     url: '/api/backend/user/logout',
//     method: 'post'
//   })
// }
